module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-about-author element-with-heading",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "about-the-author-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Want More City Owl Press Books?")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "about-the-author-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://smarturl.it/CONewsletter",
      "target": "_blank"
    }
  }, [_vm._v("Click here")]), _vm._v(" to sign up for the City Owl Press newsletter and be the first to find out about special offers, including FREE book days, contents, giveaways, cover reveals, and more!")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Sign up now and become a City Owl Reader today! And join our City Owl Reader-Author group "), _c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://smarturl.it/COReadersGroup",
      "target": "_blank"
    }
  }, [_vm._v("here")]), _vm._v(" for even more deals and a whole lot of community and fun!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67d4fb0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wantmorecityowlpressbooks.vue
// module id = 78
// module chunks = 0